import colors from '../../_shared/colors';

export default {
  rowMargin: `
    margin-bottom: 10px;
  `,
  hr: `
    width: 100%;
    height: 2px;
    background-color: ${colors.hrBorder};
  `,
  // AER-1722: a handpiece that is not holding the configuration the app shows for it is a
  // clinical-settings problem, not a cosmetic one -- it reads as a warning, not as body text.
  outOfSync: `
    color: ${colors.warning};
    font-weight: 600;
  `,
  syncUnknown: `
    color: ${colors.lightText};
  `,
};
